var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertsDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4045_5973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.541 51.5472C62.8889 40.1993 62.8889 21.8007 51.541 10.4528C40.1931 -0.895085 21.7945 -0.895086 10.4466 10.4528C-0.901297 21.8007 -0.901297 40.1993 10.4466 51.5472C21.7945 62.8951 40.1931 62.8951 51.541 51.5472Z",
    fill: "#FF5A54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6573 39.946C54.9999 51.2592 44.5953 59.5374 32.1862 60.0357L16.0691 43.9186C15.5835 43.5202 15.165 43.0307 14.8378 42.4637C13.8848 40.8139 13.8848 38.824 14.8378 37.1741L26.4195 17.1128C27.3719 15.464 29.096 14.4688 31.0003 14.4688C32.5476 14.4688 33.9759 15.1258 34.9678 16.2566L58.6573 39.946Z",
    fill: "#DB3A3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0003 33.5478C31.7456 33.5478 32.3575 32.9581 32.3843 32.213L32.7344 22.5202C32.7625 21.7316 32.1397 21.0853 31.3504 21.0853C30.8554 21.0853 31.145 21.0853 30.65 21.0853C29.8611 21.0853 29.2379 21.7316 29.2664 22.5202L29.6163 32.213C29.6431 32.958 30.255 33.5478 31.0003 33.5478ZM31.0003 36.7143C30.0205 36.7143 29.226 37.5082 29.226 38.4879C29.226 39.4674 30.0205 40.2622 31.0003 40.2622C31.9797 40.2622 32.7736 39.4674 32.7736 38.4879C32.7736 37.5082 31.9798 36.7143 31.0003 36.7143ZM35.5809 17.1138L47.1629 37.175C48.1156 38.8248 48.1156 40.8148 47.1629 42.4647C46.2109 44.1138 44.4871 45.1087 42.5827 45.1087H19.4177C17.5132 45.1087 15.7898 44.1137 14.8378 42.4647C13.8848 40.8149 13.8848 38.825 14.8378 37.175L26.4194 17.1138C27.3719 15.465 29.096 14.4697 31.0003 14.4697C32.9047 14.4696 34.6289 15.4649 35.5809 17.1138Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4045_5973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsDash);
export default __webpack_public_path__ + "static/media/alerts-dash.f5fcd7c18d96fc965b8c3f69b8ce05ca.svg";
export { ForwardRef as ReactComponent };